import options from './chart-desk-occupancy-agg.component';

export default {
    selector: 'dtChartDeskOccupancyAgg',
    options
};
